import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";
import { getSessionExpiry } from "../lib/api";
import { useOffline } from "../lib/offline";

// 23 Sep 2026 · Sanfter Hinweis kurz vor Ablauf der 8-Tage-Sitzung.
// Sichtbar nur online, in den letzten 24 h vor Ablauf. Da jeder App-Start
// die Sitzung per Sliding verlängert, erscheint er praktisch nur bei sehr
// lange offen gehaltenen Tabs. Wegklickbar für die aktuelle Sitzung.
const WARN_MS = 24 * 60 * 60 * 1000;

export default function SessionExpiryBanner() {
  const { online } = useOffline();
  const nav = useNavigate();
  const [dismissed, setDismissed] = useState(false);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 60 * 1000);
    return () => clearInterval(t);
  }, []);

  const exp = getSessionExpiry();
  const remaining = exp ? exp - now : 0;
  if (!online || dismissed || !exp || remaining <= 0 || remaining >= WARN_MS) return null;

  const hours = Math.max(1, Math.round(remaining / (60 * 60 * 1000)));
  return (
    <div
      data-testid="session-expiry-banner"
      className="sticky top-[var(--wb-header-h,96px)] z-30 flex items-center justify-center gap-2 px-4 py-2 text-[12px] md:text-[13px] text-center"
      style={{ background: "#FBF3E0", color: "#7A5B12", borderBottom: "1px solid #E7D8B0" }}
    >
      <Clock className="w-4 h-4 shrink-0" strokeWidth={1.8} />
      <span>Ihre Sitzung läuft in ca. {hours} Std. ab. Bitte melden Sie sich bald neu an.</span>
      <button
        onClick={() => nav("/login")}
        data-testid="session-expiry-relogin"
        className="ml-2 underline underline-offset-2 hover:no-underline font-semibold"
      >
        Neu anmelden
      </button>
      <button
        onClick={() => setDismissed(true)}
        data-testid="session-expiry-dismiss"
        aria-label="Ausblenden"
        className="ml-1 text-[15px] leading-none opacity-50 hover:opacity-100"
      >
        ×
      </button>
    </div>
  );
}
